import styled from 'styled-components';

import { theme } from '../../../global-styles/colors';

export const AssistancesStyles = styled.div`
  .assistances-list {
    display: grid;
    gap: 16px;
    padding: 0;
    list-style: none;
    margin-top: -24px;
  }
  .assistances-empty {
    text-align: center;
    color: ${theme.type.secondary};
  }
  .assistances-title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    &__back {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      padding: 0;
      width: 24px;
      height: 24px;
      min-width: 0;
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
  .assistances-subtitle {
    margin-top: 16px;
    color: ${theme.type.secondary};
  }
  .assistances-img {
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    img {
      height: 200px;
      width: auto;
    }
  }
  .assistances-text {
    text-align: center;
    span,
    a {
      color: ${(props) => props.theme.primary.primary50};
      display: block;
    }
    p {
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
  .remember-text,
  .media-text {
    text-align: center;
    margin: 16px 0 16px 0;
    font-size: 16px;
    line-height: 24px;
    padding-top: 24px;
  }
`;
